import { render, staticRenderFns } from "./gaoKaoLianJie.vue?vue&type=template&id=b9eb2314&scoped=true&"
import script from "./gaoKaoLianJie.vue?vue&type=script&lang=js&"
export * from "./gaoKaoLianJie.vue?vue&type=script&lang=js&"
import style0 from "./gaoKaoLianJie.vue?vue&type=style&index=0&id=b9eb2314&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9eb2314",
  null
  
)

export default component.exports